export const NotFound = () => {
  return (
    <>
      <h1 className="display-2">Invalid permissions for this page</h1>
    </>
  );
};
